import React, { useEffect, useRef } from "react";
import Chart from "chart.js";
import { customTooltips } from "../../../new/Utils/customTooltips";


const BarChart = ({ bardData, isMobile, isTablet }) => {
  const chartRef = useRef(null);
  useEffect(() => {

    const valueDisplayPlugin = {
      afterDatasetsDraw: function (chart) {
        const ctx = chart.ctx;
        ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, 'normal', Chart.defaults.global.defaultFontFamily);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'bottom';
      }
    };

    let barThickness;
    if (isMobile) {
      barThickness = 5;
    } else if (isTablet) {
      barThickness = 10;
    } else {
      barThickness = 21;
    }



    const options = {

      hover: {
        mode: null,
      },
      scales: {
        xAxes: [{


          gridLines: {
            display: false,
          },
          ticks: {
            fontColor: 'black',
            fontSize: isMobile ? 10 : 13,
          },
          barThickness: barThickness,
          categoryPercentage: 1,


        }],
        yAxes: [{

          ticks: {
            beginAtZero: true,
            max: 10,
            stepSize: 2,
            fontSize: isMobile ? 10 : 13,
          },
        }],
      },
      legend: {
        display: false



      },
      tooltips: {
        enabled: false,
        custom: customTooltips,
        callbacks: {
          title: function (tooltipItem, data) {
            const datasetIndex = tooltipItem[0].datasetIndex;
            return data.datasets[datasetIndex].label;
          },
          label: function (tooltipItem, data) {
            const value = tooltipItem.yLabel;
            return `${value}`;
          }
        }
      },
      animation: {
        duration: 0,
      },

      plugins: {
        datalabels: {
          display: false,
        },
      },
    };


    Chart.pluginService.register(valueDisplayPlugin);

    const ctx = chartRef.current.getContext("2d");


    let chartInstance = new Chart(ctx, {
      type: "bar",
      data: bardData,
      options: {
        ...options,
        tooltips: {
          ...options.tooltips,
          titleFontStyle: 'normal',
          bodyFontStyle: 'bold',
          bodyFontSize: 15
        }
      },

    });


    return () => {
      chartInstance.destroy();
      Chart.pluginService.unregister(valueDisplayPlugin);
    };
  }, [bardData]);

  return <canvas ref={chartRef} />;
};

export default BarChart;



// WEBPACK FOOTER //
// ./src/_components/common/BarChart/index.jsx